import React, { useState } from "react";
import CompositionInfo, { RhythmPlace } from "./CompositionInfo";
import Counter from "./counter";
import { RhythmImplResolved } from "./rhythms/rhythm-types";
import { YoutubeVideo } from "./YoutubeVideo";

export interface PlayAlongProps {
    videoId: string;
    counter: Counter;
    rhythm: RhythmImplResolved;
}

function PlayAlong(props: PlayAlongProps) {
    const [time, setTime] = useState(0);

    const specificRhythm = props.rhythm.impl[props.counter.portionIndex];
    const rhythm: RhythmPlace = {
        current: props.counter.beat,
        rhythm: specificRhythm,
    };

    return (
        <div className="App">
            <CompositionInfo time={time} rhythmPlace={rhythm} />
            <YoutubeVideo
                videoId={props.videoId}
                onTimeUpdate={(t) => {
                    props.counter.updateTime(t);
                    setTime(t);
                }}
            />
        </div>
    );
}

export default PlayAlong;
